import { render } from "./forgotView.vue?vue&type=template&id=76017b78"
import script from "./forgotView.vue?vue&type=script&lang=js"
export * from "./forgotView.vue?vue&type=script&lang=js"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__